import { defineComponent, onMounted, ref, computed } from 'vue';
import styles from './index.module.less';
import SubmitProblem from '@/components/SubmitProblem';
import { ElMessage, ElDialog } from 'element-plus';
import { useStore } from '@/store';
import clsx from 'clsx';
import './index.less';
import Settings from '@/components/Settings/index.vue';
import Datacom from '@/components/Datacom/index.vue';

const FormSwitch = defineComponent({
  name: 'FormSwitch',
  setup(props) {
    const store = useStore();

    const submitProblemVisible = ref(false);
    const settingsVisible = ref(false);
    const dataConfigVisible = ref(false);

    onMounted(() => {
    });

    const onSubmitProblemSuccess = () => {
      submitProblemVisible.value = false;
    };

    const onSubmitProblemClick = () => {
      ElMessage.info('播放已暂停');
      submitProblemVisible.value = true;
    };

    const onRangingClick = () => {
      if (!store.state.distanceMeasurement.status) {
        ElMessage.info('播放已暂停');
      }

      store.commit('changeDistanceMeasurement', {
        status: !store.state.distanceMeasurement.status,
      });
      store.commit('wsModule/setSelectpoint', false);
    };

    const rangingActive = computed(() => {
      return !!store.state.distanceMeasurement.status;
    });

    return {
      submitProblemVisible,
      onSubmitProblemSuccess,
      onSubmitProblemClick,
      props,
      onRangingClick,
      rangingActive,
      settingsVisible,
      dataConfigVisible
    };
  },
  render() {
    return (
      <div class={styles.container}>
        <div class={styles.btns}>
          <div class={styles['btn-item']} onClick={this.onSubmitProblemClick}>
            问题提报
          </div>
          <div
            class={clsx(styles['btn-item'], {
              [styles['active']]: this.rangingActive,
            })}
            onClick={this.onRangingClick}
          >
            测距
          </div>
          <div
            class={styles['btn-item']}
            onClick={() => {
              this.settingsVisible = true;
            }}
          >
            设置
          </div>
          <div
            class={styles['btn-item']}
            onClick={() => {
              this.dataConfigVisible = true;
            }}
          >
            数据状态
          </div>
        </div>
        <ElDialog
          v-model={this.submitProblemVisible}
          title="问题提报"
          width={920}
          destroyOnClose
          center
          draggable
          appendToBody
          class="my-info-dialog"
        >
          <SubmitProblem onSubmitSuccess={this.onSubmitProblemSuccess} />
        </ElDialog>
        <ElDialog
          v-model={this.settingsVisible}
          title="设置"
          width={800}
          destroyOnClose
          center
          draggable
          appendToBody
          class="my-info-dialog"
        >
          <Settings
            onSubmitSuccess={() => {
              this.settingsVisible = false;
            }}
          />
        </ElDialog>
        <ElDialog
          v-model={this.dataConfigVisible}
          title="数据状态"
          width={800}
          center
          draggable
          appendToBody
          class="my-info-dialog"
          modal={false}
          close-on-click-modal={false}
          modal-class="dialog_class"
        >
          <Datacom
            onSubmitSuccess={() => {
              this.dataConfigVisible = false;
            }}
          />
        </ElDialog>
      </div>
    );
  },
});

export default FormSwitch;
